module.exports = __webpack_public_path__ + "img/circle-8.06737aa4.svg";